/**
 * @file ppde页banner下面的图片列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';
import {Col, Row} from 'antd';

import {IBannerPictureCardGroupProps, IBannerPictureCardItem} from './types';
import A from '../../../../components/a/A';

const BannerPictureCardGroup: React.FC<IBannerPictureCardGroupProps> = (props) => {
    const list = useMemo(() => {
        const theLIst = props.list || (new Array(4)).fill({});
        return theLIst.map<IBannerPictureCardItem>((item, index) => ({
            key: index,
            ...item
        }));
    }, [props.list]);

    const xsSpan = useMemo(() => {
        if (list.length === 0) {
            return 12;
        }
        if (list.length <= 4) {
            return 24 / list.length;
        }
        return 6;
    }, [list]);

    return (
        <Row
            className="paddle-ppde-banner-picture-card-wrap"
            gutter={[10, 10]}
        >
            {list.map((item) => (
                <Col xs={xsSpan} key={item.key} className="paddle-ppde-banner-picture-card-wrap">
                    <A
                        href={item.link}
                        target
                        className="paddle-ppde-banner-picture-card"
                    >
                        <div
                            className="paddle-ppde-banner-picture-card-bg"
                            style={{backgroundImage: item.img ? `url(${item.img})` : undefined}}
                        />
                        <div className="paddle-ppde-banner-picture-card-info">
                            <div className="paddle-ppde-banner-picture-card-title">{item.title}</div>
                            <div
                                className="paddle-ppde-banner-picture-card-text"
                                {...{dangerouslySetInnerHTML: {__html: item.text || ''}}}
                            />
                            <div className="paddle-ppde-banner-picture-card-btn-group">
                                <span>{item.btnText}</span>
                                <span className="paddle-ppde-banner-picture-card-btn-arrow" />
                            </div>
                        </div>
                    </A>
                </Col>
            ))}
        </Row>
    );
};

export default BannerPictureCardGroup;
